export type CardDataProps = {
  id: number;
  name: string;
  content: string;
  rate: number;
};

const testimonials: CardDataProps[] = [
  {
    id: 1,
    name: 'Emily R.',
    rate: 5,
    content:
      'I used this tool to remove watermarks from my graduation photos, and the results were flawless! The process was quick and easy, preserving the quality of every image. Highly recommend it for anyone looking to save their special moments without distractions!',
  },
  {
    id: 2,
    name: 'Anthony D.',
    rate: 5,
    content:
      "Wow! This tool saved my family reunion photos. The watermark was right in the middle of everyone's smiles, but now they look perfect! Five stars.",
  },
  {
    id: 3,
    name: 'Renee A.',
    rate: 5,
    content:
      "I couldn't be happier with this tool! My newborn baby's first photos had watermarks from the photographer, but now they look absolutely perfect. Thank you for helping me treasure these once-in-a-lifetime memories!",
  },
  {
    id: 4,
    name: 'Jasmine T.',
    rate: 5,
    content:
      'As someone who loves editing and sharing photos online, this tool is a lifesaver. It removed watermarks so smoothly. Now my feed looks way more aesthetic now.',
  },
  {
    id: 5,
    name: 'Alison P.',
    rate: 5,
    content:
      "My son's first soccer game was a big deal for us, and I wanted to frame the best action shot. This app removed the watermark effortlessly, leaving me with a clean, high-quality picture. Thank you!!!",
  },
  {
    id: 6,
    name: 'Megan H.',
    rate: 5,
    content:
      "I had this gorgeous photo from my beach vacation, but the watermark totally spoiled the mood. This app fixed it perfectly, and now it's my phone wallpaper. I'm seriously impressed!",
  },
];

export default testimonials;
